import type { I18nOptions } from 'vue-i18n';

const options: I18nOptions = {
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'en',
  missingWarn: false,
  fallbackWarn: false,
};
export default defineI18nConfig(() => options);
